import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AnnualStatement } from "@models/annual-statements/annual-statement";
import { AnnualStatementPageFilter } from "@models/annual-statements/annual-statement-enums";
import { AnnualStatementRecord } from "@models/annual-statements/annual-statement-record";
import { PageResult } from "@models/requests/page-result.interface";
import BaseApiService from "@shared/services/base/base-api.service";
import { IServerSideGetRowsRequest } from "ag-grid-enterprise";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AnnualStatementsApiService extends BaseApiService {
  getAnnualList(request: IServerSideGetRowsRequest, pageFilter: AnnualStatementPageFilter, search?: string, startRow?: number, endRow?: number): Observable<PageResult<AnnualStatementRecord>> {
    if (startRow !== null && startRow !== undefined) {
      request.startRow = startRow;
    }

    if (endRow) {
      request.endRow = endRow;
    }

    let params = new HttpParams();

    if (search) {
      params = params.append('search', search);
    }

    const options = { params: params };
    const body = { ...request, pageFilter };

    return this.api.post<PageResult<AnnualStatementRecord>>(`${ this.apiUrl }/annual-statements/grid`, body, options)
      .pipe(
        map(data => {
          data.records = data.records.map(d => new AnnualStatementRecord(d));
          return data;
        })
      );
  }

  getAnnualById(id: string): Observable<AnnualStatement> {
    return this.api.get<AnnualStatement>(`${ this.apiUrl }/annual-statements/${ id }`)
      .pipe(
        map((annualStatement) => new AnnualStatement(annualStatement))
      );
  }

  annualGenerate(body: AnnualStatement): Observable<string> {
    return this.api.post<string>(`${ this.apiUrl }/annual-statements/generate`, body);
  }

  archive(id: string): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/annual-statements/${ id }/archive`, null);
  }

  markAsPaidBulk(ids: string[]): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/annual-statements/mark-as-paid`, ids);
  }

  ignore(id: string): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/annual-statements/${ id }/ignore`, null);
  }

  ignoreBulk(ids: string[]): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/annual-statements/bulk/ignore`, ids);
  }

  annualRegenerate(companyId: string): Observable<string> {
    return this.api.post<string>(`${ this.apiUrl }/annual-statements/${ companyId }/regenerate`, { id: companyId });
  }

  reprintAS(companiesId: string[]): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/annual-statements/reprint`, companiesId);
  }

  annualRegenerateBulk(companiesId: string[]): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/annual-statements/bulk/regenerate`, companiesId);
  }

  resetAnnualStatementSendViaEmail(annualStatementId: string): Observable<AnnualStatement> {
    return this.api.post<AnnualStatement>(`${ this.apiUrl }/annual-statements/${ annualStatementId }/reset`, null);
  }
}
